import React from 'react';

type Props = {
  children: React.ReactNode;
};

function ErrorLabel({ children }: Props) {
  return (
    <label
      htmlFor="input"
      className="text-red-600 text-xs pb-1"
    >
      {children}
    </label>
  );
}

export default ErrorLabel;
